import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ChartOptions,
} from 'chart.js';
import {Line} from 'react-chartjs-2';

import {useMediaQuery, useTheme} from '@mui/material';

import {greenColors} from '../../../../../layouts/theme/designSystem';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement);

interface Dataset {
  label?: string;
  data: number[] | undefined;
  borderColor: string;
}

interface LineChartData {
  labels?: string[];
  datasets: Dataset[];
}

interface Props {
  data: LineChartData;
}

export const LineChart = ({data}: Props) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));

  const options: ChartOptions<'line'> = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        align: isXs ? 'center' : 'end',
        labels: {
          color: greenColors[70],
          font: {
            size: 16,
          },
          boxWidth: 10,
          boxHeight: 10,
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          autoSkip: false,
          maxRotation: 90,
          color: greenColors[700],
          font: {
            size: 16,
            lineHeight: '30px',
          },
        },
      },
      y: {
        grid: {
          display: false,
        },
        ticks: {
          autoSkip: false,
          color: greenColors[700],
          font: {
            size: 16,
            lineHeight: '30px',
          },
        },
      },
    },
  };

  return <Line data-testid='line-chart' data={data} options={options} />;
};
